"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrowCycleStatusBadge = GrowCycleStatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../../table");
var STATUS_COLORS = {
    OPEN: "amber",
    ACTIVE: "navy",
    COMPLETE: "green-soft",
    OVERDUE: "red-solid",
};
function GrowCycleStatusBadge(props) {
    var status = props.status;
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: STATUS_COLORS[status], children: status });
}
